import * as types from '../mutation-types';
import TicketsAPI from '../../api/tickets';

const state = {
  records: {},
};

export const getters = {
  getUserList: $state => ticketId => {
    return $state.records[Number(ticketId)] || [];
  },
};

export const actions = {
  toggleTyping: async (_, { ticketId, status, isPrivate }) => {
    try {
      await TicketsAPI.toggleTypingStatus(ticketId, status, isPrivate);
    } catch (error) {
      // Handle error
    }
  },
  create: ({ commit }, { ticketId, user }) => {
    commit(types.default.ADD_USER_TYPING_TO_TICKET, {
      ticketId,
      user,
    });
  },
  destroy: ({ commit }, { ticketId, user }) => {
    commit(types.default.REMOVE_USER_TYPING_FROM_TICKET, {
      ticketId,
      user,
    });
  },
};

export const mutations = {
  [types.default.ADD_USER_TYPING_TO_TICKET]: ($state, { ticketId, user }) => {
    const records = $state.records[ticketId] || [];
    const hasUserRecordAlready = !!records.filter(
      record => record.id === user.id && record.type === user.type
    ).length;
    if (!hasUserRecordAlready) {
      $state.records = {
        ...$state.records,
        [ticketId]: [...records, user],
      };
    }
  },
  [types.default.REMOVE_USER_TYPING_FROM_TICKET]: (
    $state,
    { ticketId, user }
  ) => {
    const records = $state.records[ticketId] || [];
    const updatedRecords = records.filter(
      record => record.id !== user.id || record.type !== user.type
    );
    $state.records = {
      ...$state.records,
      [ticketId]: updatedRecords,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
